import Exception500 from './500.vue'

export default Exception500
